import { Toaster as HotToaster } from 'react-hot-toast';

export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        className: '',
        duration: 4000,
        style: {
          background: '#FFFFFF',
          color: '#000000',
          border: '1px solid #DEE3E9',
          borderRadius: '12px',
          padding: '16px 20px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.05)',
          fontSize: '14px',
          fontWeight: '500',
        },

        // Success — cyan accent from btn-gradient start
        success: {
          duration: 4000,
          style: {
            background: '#FFFFFF',
            color: '#000000',
            border: '1px solid #DEE3E9',
            borderLeft: '4px solid #FFC800',
            boxShadow: '0 4px 16px rgba(255, 200, 0, 0.18), 0 1px 4px rgba(0, 0, 0, 0.05)',
            borderRadius: '0 12px 12px 0',
          },
          iconTheme: {
            primary: '#FFC800',
            secondary: '#FFFFFF',
          },
        },

        // Error — red/pink accent from btn-gradient2 end
        error: {
          duration: 5000,
          style: {
            background: '#FFFFFF',
            color: '#000000',
            border: '1px solid #DEE3E9',
            borderLeft: '4px solid #DD2345',
            boxShadow: '0 4px 16px rgba(221, 35, 69, 0.12), 0 1px 4px rgba(0, 0, 0, 0.05)',
            borderRadius: '0 12px 12px 0',
          },
          iconTheme: {
            primary: '#DD2345',
            secondary: '#FFFFFF',
          },
        },

        // Loading — purple accent from btn-gradient2 start
        loading: {
          style: {
            background: '#FFFFFF',
            color: '#000000',
            border: '1px solid #DEE3E9',
            borderLeft: '4px solid #702B73',
            boxShadow: '0 4px 16px rgba(112, 43, 115, 0.12), 0 1px 4px rgba(0, 0, 0, 0.05)',
            borderRadius: '0 12px 12px 0',
          },
          iconTheme: {
            primary: '#702B73',
            secondary: '#FFFFFF',
          },
        },

        // Blank/info — pink accent from btn-gradient end
        blank: {
          style: {
            background: '#FFFFFF',
            color: '#000000',
            border: '1px solid #DEE3E9',
            borderLeft: '4px solid #434343',
            boxShadow: '0 4px 16px rgba(246, 150, 255, 0.12), 0 1px 4px rgba(0, 0, 0, 0.05)',
            borderRadius: '0 12px 12px 0',
          },
        },
      }}
    />
  );
}
